import either, { right } from "@/lib/either";
import AuthRemoteDataSource from "../datasource/auth_remote_datasource";

const GetIpUsecase = () =>
  either(async () => {
    const response = await AuthRemoteDataSource.getIp();

    return right(response);
  });

export default GetIpUsecase;
